export function LoginReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_FIELD': 
        return {
            ...state,
            [action.field]: action.value,
        };
    };
};